import { Button, Box } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import './SignIn.css'

function SignIn() {
  const  { login }  = UserAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(email, password);
      navigate("/scores");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Box className="signin-container">

      <div className="login-container ">
        <img
          className="login-keff-logo"
          src={process.env.PUBLIC_URL + "Assets/Keff_logo.png"}
          alt="keff_logo"
        ></img>
      <div className="login_inner-container">
      <form className="signin-form" onSubmit={handleLogin}>
        <div className="login-field">
          <label className="login-label">אימייל</label>
          <input
          className="login-input" onChange={(e) => setEmail(e.target.value)} type="email" />
        </div>
        <div className="login-field">
          <label className="login-label">סיסמא</label>
          <input
          className="login-input"
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </div>
        <p>{error}</p>
        <div className="login-block"></div>
        <Button className="signin-btn" variant="contained" size="small" type="submit"><p className="login-btn-txt">התחבר</p></Button>
      </form>
      </div>
    </div>
    </Box>
  );
}

export default SignIn;
